import React, { memo } from 'react'
import './index.scss'
import IconNew from 'components/elements/iconsSize'
import image1 from 'assets/images/ResourcesModal/image1.png'
import image2 from 'assets/images/ResourcesModal/image2.png'
import image3 from 'assets/images/ResourcesModal/image3.png'
import image4 from 'assets/images/ResourcesModal/image4.png'
import image5 from 'assets/images/ResourcesModal/image5.webp'
import Text, { TYPES as types, SIZES as sizes, TextWithIcon } from 'components/elements/Text'
import { useNavigate } from 'react-router-dom'


const ResourcesModalContent = ({onClose}) => {
    const navigate = useNavigate()
    return (
        <div className="flex relative resources__modal__content">
            <div className="absolute top-[-20%] left-[-2%]">
                <IconNew name='LabelResources' />
            </div>
            <div className="flex w-full gap-6 justify-center">
                <div
                    className="flex w-full justify-center flex-col gap-2 cursor-pointer"
                    role='presentation'
                    onClick={() => {
                        onClose();
                        window.open('https://miestrouniversity.miestro.com/', '_blank')
                    }}
                >
                    <Text
                        inner='Miestro University'
                        type={types.regular148}
                        size={sizes.medium}
                    />
                    <img src={image1} alt="online course platform" className='w-[160px] h-[160px]' />
                    <TextWithIcon
                        inner='Click Here'
                        type={types.regularDefaultSmall}
                        generalStyles={{ cursor: 'pointer' }}
                        size={sizes.small}
                        iconName='JoinNowArrowM'
                        isIconRight={true}
                        iconGap={6}
                        style={{ color: '#24554E' }}
                    />
                </div>
                <div
                    className="flex w-full justify-center flex-col gap-2 cursor-pointer"
                    role='presentation'
                    onClick={() => {
                        onClose();
                        window.open('https://www.facebook.com/groups/miestro', '_blank')
                    }}
                >
                    <Text
                        inner='Facebook Community'
                        type={types.regular148}
                        size={sizes.medium}
                    />
                    <img src={image2} alt="online course platform" className='w-[160px] h-[160px]' />
                    <TextWithIcon
                        inner='Click Here'
                        type={types.regularDefaultSmall}
                        generalStyles={{ cursor: 'pointer' }}
                        size={sizes.small}
                        iconName='JoinNowArrowM'
                        isIconRight={true}
                        iconGap={6}
                        style={{ color: '#24554E' }}
                    />
                </div>
                <div
                    className="flex w-full justify-center flex-col gap-2 cursor-pointer"
                    role='presentation'
                    onClick={ () => {
                        onClose();
                        navigate('/demo');
                    } }
                >
                    <Text
                        inner='Demo'
                        type={types.regular148}
                        size={sizes.medium}
                    />
                    <img src={image3} alt="online course platform" className='w-[160px] h-[160px]' />
                    <TextWithIcon
                        inner='Click Here'
                        type={types.regularDefaultSmall}
                        generalStyles={{ cursor: 'pointer' }}
                        size={sizes.small}
                        iconName='JoinNowArrowM'
                        isIconRight={true}
                        iconGap={6}
                        style={{ color: '#24554E' }}
                    />
                </div>
                <div
                    className="flex w-full justify-center flex-col gap-2 cursor-pointer"
                    role='presentation'
                    onClick={() => {
                        onClose();
                        window.open('https://blog.miestro.com/', '_blank');
                    }}
                >
                    <Text
                        inner='Blog'
                        type={types.regular148}
                        size={sizes.medium}
                    />
                    <img src={image4} alt="online course platform" className='w-[160px] h-[160px]' />
                    <TextWithIcon
                        inner='Click Here'
                        type={types.regularDefaultSmall}
                        generalStyles={{ cursor: 'pointer' }}
                        size={sizes.small}
                        iconName='JoinNowArrowM'
                        isIconRight={true}
                        iconGap={6}
                        style={{ color: '#24554E' }}
                    />
                </div>
                <div
                    className="flex w-full justify-center flex-col gap-2 cursor-pointer"
                    role='presentation'
                    onClick={() => {
                        onClose();
                        window.open('https://training.miestro.com/resources', '_blank');
                    }}
                >
                    <Text
                        inner='Training'
                        type={types.regular148}
                        size={sizes.medium}
                    />
                    <img src={image5} alt="online course platform" className='w-[160px] h-[160px] object-cover rounded-xl' />
                    <TextWithIcon
                        inner='Click Here'
                        type={types.regularDefaultSmall}
                        generalStyles={{ cursor: 'pointer' }}
                        size={sizes.small}
                        iconName='JoinNowArrowM'
                        isIconRight={true}
                        iconGap={6}
                        style={{ color: '#24554E' }}
                    />
                </div>
            </div>
            <div className="absolute top-[-10%] right-[-2%]">
                <IconNew name='VectorResources' />
            </div>
        </div>
    )
}

export default memo(ResourcesModalContent)
